import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import SolubilityQuizScores from './solubility-quiz-scores.component';

export class VisitorsComponent {
    constructor() {
        this.componentName = "visitorsComponent";
        this.template = `
            <h3>Visitors</h3>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Month</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody id="data_row">
        <tr class="table-default">
          <td scope="row">January 2020</td>
          <td>100</td>
        </tr>
      </tbody>
    </table>
        `;
        
        this.rowTemplate = `
        <tr class="table-default">
          <td scope="row">{MonthYear}</td>
          <td>{Count}</td>
        </tr>
        `;
        this.cache = undefined;
		this.cacheExpiration = undefined;
    }

	
	render() {
        _svc.common.renderResults("Visitors", _cmp.visitors);
    }
    
	postBackSuccess(data) {
      _svc.common.populateDataRows(data, _cmp.visitors.rowTemplate, _cmp.visitors.componentName, _cmp.visitors.template);
      _svc.common.handleCache(_cmp.visitors);
	}
	
	postBackFailed() {
		_svc.util.clear("#" + _cmp.visitors.componentName);
	}
	
	cacheExpired() {
		if (_cmp.visitors.cacheExpiration == undefined) return true;
		if (_cmp.visitors.cache == undefined) return true;
		return _cmp.visitors.cacheExpiration < _svc.util.now();
	}
};

setTimeout(() => {
    _cmp.visitors = new VisitorsComponent();
}, 1);